(ns basic-components.popover
  (:require
   [frontend.bootstrap.components :as rbs]
   [reagent.core :as r]
   [frontend.utils :as fu]))

(defn view
  ([popover-title-text popover-content-text hiccup header?]
   (view popover-title-text popover-content-text hiccup header? nil))
  ([popover-title-text popover-content-text hiccup header? options]
   [rbs/OverlayTrigger
    (merge
     {:placement     "top"
      :popper-config {:modifiers [{:name    "preventOverflow"
                                   :options {:main-axis false}}
                                  {:name "hide"}]}
      :overlay       (r/as-element [rbs/Popover
                                    {:class (fu/cs "in")
                                     :id    (str "popover-" popover-content-text)}
                                    (when header? [rbs/PopoverTitle popover-title-text])
                                    [rbs/PopoverContent popover-content-text]])}
     options)
    hiccup]))
